import { Chip, Grid } from '@mui/material';
import { AppContextProps } from '../../../../libs/app-core/AppContext';
import { MessageDialog } from '../../../../libs/app-core/dialogs/MessageDialog';
import { ROUTE_dev_quest_v3 } from '../../../Routes';
import { Member } from '../../../dao/Member';
import { UniAnswerDAO } from '../../../dao/UniAnswerDAO';
import { UniFunc } from '../../../dao/UniFunc';
import { FrmSpwkQuestProps } from '../../FrmSpwkQuestionnaire';

type Props = {
  ctx: AppContextProps
  member: Member;
  is_spwk: boolean;
  UniFuncListCache: UniFunc[];
}

const UcUniFuncPills = ({ ctx, member, is_spwk, UniFuncListCache }: Props) => {

  let uni_func_guids = (is_spwk ? member.getSpwkUniFuncGuids() : member.getCommonUniFuncGuids());

  return (
    <Grid container spacing={1}>

      {(is_spwk === true ? render_Pill("ALL", "ALL", member.getSpwkUniFuncGuids()) : undefined)}

      {uni_func_guids.map((uni_func_guid) => {
        var find = UniFuncListCache.find(x => x.guid === uni_func_guid);



        if (find == null) {
          return render_Pill(uni_func_guid, "???", []);
        } else {
          return render_Pill(uni_func_guid, find.func_code, [find.guid]);
        }

      })}
    </Grid>
  );

  function render_Pill(uni_func_guid: string, pill_text: string, uni_func_guids: string[]) {
    return (
      <Grid item key={uni_func_guid}>
        <Chip color="primary" variant="outlined" sx={{ cursor: 'pointer' }}
          label={pill_text}
          onClick={async () => {
            if (uni_func_guids.length === 0) {
              return;
            }

            OpenPageFrmSpwkQuestV3(member, pill_text, uni_func_guid, ctx);
            return;

          }
          }
        />
      </Grid>
    );
  }
}

export default UcUniFuncPills

async function OpenPageFrmSpwkQuestV3(member: Member, pill_text: string, uni_func_guid: string, ctx: AppContextProps) {
  let answer_list = await UniAnswerDAO.DB_Select_ByMemberGuid(member.guid);

  if (answer_list.length === 1) {

    let params: FrmSpwkQuestProps = {
      answer_guid: answer_list[0].guid,
      func_guid: (pill_text === "ALL" ? undefined : uni_func_guid)
    };

    ctx.Navigate(ROUTE_dev_quest_v3.url, { state: params });
    // ctx.Navigate("/dev/FrmSpwkQuestV3", { state: params });

  } else if (answer_list.length === 0) {
    MessageDialog.Show(ctx, "尚未設定 Answer !");

  } else {
    MessageDialog.Show(ctx, "多於一個 Answer !?");

  }
}

